module.exports = __webpack_public_path__ + "media/images/kids12-dc03d0148dba702e39cff891b4186101.jpg";